<template>
  <button type="button" data-cookiebanner-approve @click="approve">
    <slot />
  </button>
</template>

<script setup>
import { inject } from 'vue';
const approve = inject('cookiebanner/approve');
</script>
